import React, { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { t } from '../utils/translations'
import AppBranding from '../components/AppBranding'

export default function Login() {
  const { login, error, clearError } = useAuth()
  const [lang, setLang] = useState('zh')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    clearError()

    const result = await login(username, password)

    if (!result.success) {
      setLoading(false)
    }
    // On success, the auth context will redirect automatically
  }

  const toggleLanguage = () => {
    setLang(lang === 'zh' ? 'en' : 'zh')
  }

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Language Toggle */}
        <button className="btn-language-top" onClick={toggleLanguage}>
          {lang === 'zh' ? 'English' : '中文'}
        </button>

        {/* Logo/Title */}
        <div className="login-header">
          <AppBranding lang={lang} />
          <p>{lang === 'zh' ? 'HKMBC 香港聖經教會' : 'HKMBC Hong Kong Bible Church'}</p>
        </div>

        {/* Error Message */}
        {error && (
          <div className="message message-error">
            {error}
          </div>
        )}

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">{t('username', lang)}</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder={lang === 'zh' ? '輸入使用者名稱' : 'Enter username'}
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">{t('password', lang)}</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={lang === 'zh' ? '輸入密碼' : 'Enter password'}
              required
            />
          </div>

          <button
            type="submit"
            className="btn-login"
            disabled={loading}
          >
            {loading ? t('loading', lang) : t('login', lang)}
          </button>
        </form>

        {/* Footer */}
        <div className="login-footer">
          <p>{lang === 'zh' ? '忘記密碼？請聯繫系統管理員' : 'Forgot password? Contact system administrator'}</p>
        </div>
      </div>

      <style jsx>{`
        .login-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--bg-primary);
        }

        .login-container {
          width: 100%;
          max-width: 400px;
          padding: 40px;
          background-color: var(--bg-card);
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);
          position: relative;
        }

        .btn-language-top {
          position: absolute;
          top: 16px;
          right: 16px;
          padding: 8px 12px;
          background-color: transparent;
          border: 1px solid var(--border-color);
          border-radius: var(--border-radius);
          color: var(--text-secondary);
          cursor: pointer;
          font-size: 0.875rem;
          transition: all 0.2s;
        }

        .btn-language-top:hover {
          background-color: var(--bg-hover);
          color: var(--text-primary);
        }

        .login-header {
          text-align: center;
          margin-bottom: 32px;
        }

        .login-header .app-branding {
          width: 100%;
          justify-content: space-between;
        }
        .login-header .app-branding-title {
          color: var(--accent-primary);
          font-weight: 700;
        }

        .login-header .app-branding-subtitle {
          color: var(--text-muted);
        }

        .login-header p {
          color: var(--text-muted);
          font-size: 0.875rem;
          margin: 0;
        }

        .login-form {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .form-group label {
          color: var(--text-secondary);
          font-weight: 500;
        }

        .form-group input {
          padding: 12px 16px;
          background-color: var(--bg-input);
          border: 2px solid var(--input-border, var(--border-color));
          border-radius: var(--border-radius);
          color: var(--text-primary);
          font-size: 1rem;
          transition: all 0.2s;
        }

        .form-group input:focus {
          outline: none;
          border-color: var(--accent-primary);
          background-color: var(--bg-hover);
        }

        .form-group input::placeholder {
          color: var(--text-muted);
        }

        .btn-login {
          padding: 14px 24px;
          background-color: var(--accent-primary);
          border: none;
          border-radius: var(--border-radius);
          color: white;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
          margin-top: 8px;
        }

        .btn-login:hover:not(:disabled) {
          background-color: var(--accent-primary);
        }

        .btn-login:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .message-error {
          background-color: rgba(239, 68, 68, 0.1);
          border: 1px solid var(--accent-danger);
          color: var(--accent-danger);
          padding: 12px 16px;
          border-radius: var(--border-radius);
          margin-bottom: 20px;
          text-align: center;
        }

        .login-footer {
          margin-top: 24px;
          text-align: center;
        }

        .login-footer p {
          color: var(--text-muted);
          font-size: 0.875rem;
          margin: 0;
        }
      `}</style>
    </div>
  )
}